const selectors = {
  getLeadTargetResult: (state) => state.rcrm.getLeadTargetResult,
  saveCRMSettingLeadFormResult: (state) => state.rcrm.saveCRMSettingLeadFormResult,
  setGateItemResult: (state) => state.rcrm.setGateItemResult,
  saveCRMGGLeadsSettingResult: (state) => state.rcrm.saveCRMGGLeadsSettingResult,
  setCRMLoadingResult: (state) => state.rcrm.setCRMLoadingResult,
  setValidateGateResult: (state) => state.rcrm.setValidateGateResult,
};

export default selectors;
